module.exports = __webpack_public_path__ + "static/media/026.0a94515f.png";